<template>
  <div class="level is-mobile">
    <div class="level-item has-text-centered">
      <div>
        <p class="title is-4">{{ race.speed + bonuses.speed }} ft.</p>
        <p class="heading">SPEED</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="title is-4">+{{ difficulty.profBonus }}</p>
        <p class="heading">PROF.</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div class="armor">
        <p class="title is-4">{{ armor }}</p>
        <p class="heading">ARMOR</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div class="health" @click="$emit('healthClicked')">
        <p class="title is-4">{{ health }} / {{ maxHealth }}</p>
        <p class="heading">HEALTH <span>({{ characterClass.healAmount }})</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'
import { useRoute } from 'vue-router'
import plusOrMinus from '@/helpers/plusOrMinus'

export default defineComponent({
  setup () {
    const route = useRoute()
    const character = inject('character')
    const computedCharacter = inject('computedCharacter')

    const health = computed(() => {
      return route.meta.create 
        ? computedCharacter.maxHealth.value
        : character.health
    })

    return {
      health,
      plusOrMinus,
      character,
      ...computedCharacter
    }
  }
})
</script>

<style lang="sass" scoped>
.title
  margin-bottom: 0.5rem !important
  font-family: 'Playfair Display', serif

.heading
  margin-bottom: 0 !important
  font-weight: bold
  font-family: 'Roboto', sans-serif
  span
    text-transform: none

.armor
  position: relative
  &::after
    content: ''
    display: block
    width: 4rem
    height: 4rem
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    background-image: url('../../../public/images/armorOutline.svg')
    background-size: contain
    background-position: center
    background-repeat: no-repeat
    opacity: 0.15

.health
  position: relative
  cursor: pointer
  &::after
    content: ''
    display: block
    width: 6rem
    height: 4rem
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    border: solid 2px #000
    opacity: 0.15
  &:hover
    &::after
      opacity: 0.3
</style>
